<template>
  <div>
    <section class="section has-text-centered-mobile">
      <div class="container">
        <div class="title">{{titulo}}</div>
        <div class="subtitle">{{subtitulo}}</div>
        <div class="is-divider is-secundary" ></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TituloPrincipal',
  props: ['titulo', 'subtitulo']
}
</script>
